import React from 'react';
import { Form, Col } from 'react-bootstrap';

const FormikInput = ({
  placeholder,
  label,
  size,
  margin,
  error,
  touched,
  helpText,
  inputType,
  abbr,
  inputAs,
  ...props
}) => (
  <Form.Group className={margin} as={Col}>
    {label ? (
      <Form.Label>
        <span style={{ fontSize: '0.81rem', fontWeight: 600 }}> {label} </span>{' '}
        {abbr ? <abbr className="text-danger">*</abbr> : false}
      </Form.Label>
    ) : (
      false
    )}
    <Form.Control
      size={size}
      placeholder={placeholder}
      type={inputType}
      as={inputAs}
      className={error && touched ? 'is-invalid' : ''}
      {...props}
    />
    {error && touched ? <Form.Text className="text-danger ml-1">{error}</Form.Text> : null}
    {helpText ? <Form.Text className="text-muted">{helpText}</Form.Text> : null}
  </Form.Group>
);

export default FormikInput;
